import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import File from 'components/File';
import {
  getSharedBookingFiles,
  getRecentlySharedBookingFiles,
} from 'actions/files';
// import { CircularProgress } from '@mui/material';

const styles = () => ({
  files: {
    display: 'flex',
    flexWrap: 'wrap',
    padding: '20px 0px',
    maxHeight: 625,
    overflowY: 'auto',
  },
  emptyFiles: {
    display: 'flex',
    padding: '20px 0',
    minHeight: 400,
    fontSize: 14,
  },
  loading: {
    display: 'flex',
    margin: 20,
  },
});

class Files extends Component {
  state = {
    files: [],
  };

  componentDidMount() {
    // const { bookingId } = this.props;
    // if (bookingId) {
    //   this.props.getSharedBookingFiles(bookingId).then(files => {
    //     this.setState({ files });
    //   });
    // } else {
    //   this.props.getRecentlySharedBookingFiles().then(files => {
    //     this.setState({ files });
    //   });
    // }
  };

  render() {
    const {
      classes,
      booking,
    } = this.props;

    // const {
    //   files,
    // } = this.state;

    return (
      <>
        {/* files.length === 0 ? <div className={classes.loading}><CircularProgress /></div> :/ */}
        {booking && booking.eventDetails && booking.eventDetails.eventFiles && booking.eventDetails.eventFiles.length > 0 ?
          <div className={classes.files}>
            {booking.eventDetails.eventFiles.map(file => {
              return <File file={file} key={file.id} />;
            })}
          </div> :
          <div className={classes.emptyFiles}>There are no shared files.</div>}
      </>
    );
  }
}

const mapDispatchToProps = {
  getSharedBookingFiles,
  getRecentlySharedBookingFiles,
};

export default connect(undefined, mapDispatchToProps)(withStyles(styles)(Files));
